import {useState} from 'react'
import {useClientCart} from '../../core/clientProvider'
import Swal from 'sweetalert2'
import {useCart} from '../../core/cartProvider'
import {SaleButton} from './sale'
import {BudgetButton} from './budget'
import {TokenModalSale} from '../Token/modalToken'
import {NoticeModalSale} from '../Notice/NoticeModalSale'
import {LoadingBudget} from '../alert/loadingBudget'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {copyToBudget} from '../../../../../utils/copyToBudget'
import useAuthorization from '../../../../../hooks/useAuthorization'
import {useAuth} from '../../../../../app/modules/auth'
import {approveBudgetReview, rejectBudgetReview} from '../../../../budgets/core/_request'

function getBadge(sum, customerAssociate, responsibleAssociate, shoppingCart) {
  if (customerAssociate == null) {
    return 'Adicione um cliente à venda.'
  } else if (
    customerAssociate.physicalPerson.birthDate &&
    customerAssociate.physicalPerson.age < 18 &&
    responsibleAssociate == null
  ) {
    return 'Adicione um responsável à venda.'
  } else if (sum === 0 && shoppingCart.length === 0) {
    return 'Adicione itens no carrinho :('
  } else if (sum === 0 && shoppingCart.length !== 0) {
    return 'Gerar Cobrança'
  } else {
    return 'Pagamento'
  }
}

function getBudget(sum, customerAssociate, budgetData) {
  if (customerAssociate == null) {
    return 'Adicione um cliente à venda.'
  } else if (sum === 0) {
    return 'Adicione itens no carrinho :('
  } else {
    return newOrExistBudget(budgetData)
  }
}

function isNewBudget(budgetData) {
  return budgetData == null
}

function newOrExistBudget(budgetData) {
  return isNewBudget(budgetData) ? 'Orçamento' : 'Atualizar'
}

const isExpiresAtBudget = (budgetData) => {
  if (!budgetData || !budgetData.expiresAt) {
    return false
  }
  const expiryDate = new Date(budgetData.expiresAt.replace(' ', 'T'))
  const now = new Date()
  return expiryDate < now
}

const verifyDisableButton = (sum, client, responsibleAssociate, shoppingCart) => {
  if (sum == 0 && shoppingCart.length === 0) {
    return true
  }

  if (sum == 0 && shoppingCart.length !== 0) {
    return true
  }

  if (client == null) {
    return true
  }

  if (
    client.physicalPerson.birthDate &&
    client.physicalPerson.age < 18 &&
    responsibleAssociate == null
  ) {
    return true
  }
}

const verifyDisableBudgetButton = (sum, client, shoppingCart) => {
  if (sum == 0 && shoppingCart.length == 0) {
    return true
  }

  if (sum == 0 && shoppingCart.length !== 0) {
    return true
  }
  if (client == null) {
    return true
  }
}

const verifyHasGiftSale = (sum, client, responsibleAssociate, shoppingCart) => {
  if (sum != 0 || shoppingCart.length === 0) {
    return false
  }

  if (client == null) {
    return false
  }

  if (
    client.physicalPerson.birthDate &&
    client.physicalPerson.age < 18 &&
    responsibleAssociate == null
  ) {
    return false
  }

  return true
}

export const FinishSaleButtons = () => {
  const {
    setShowPaymentModal,
    sum,
    sale,
    setBudgetForSale,
    generateBudget,
    responsibleAssociate,
    shoppingCart,
    setOpenTokenModal,
    openTokenModal,
    budgetData,
    setBudgetData,
    setEnableBudget,
    customerAssociate,
    generateGiftSale,
  } = useCart()

  const {setShowEditPersonModal, client, isRestrictClient, isRestrictClientApproved} =
    useClientCart()
  const navigate = useNavigate()
  const badge = getBadge(sum, client, responsibleAssociate, shoppingCart)
  const budget = getBudget(sum, client, budgetData)
  const [loading, setLoading] = useState(false)
  const [loadingSale, setLoadingSale] = useState(false)
  const isUpdate = budgetData != null
  const [actionPayment, setActionPayment] = useState<'BUDGET' | 'GIFT' | ''>('')
  const {
    token: {state},
  } = useCart()
  const {currentFranchise, currentUser} = useAuth()
  const discountApprovalMode = currentFranchise?.config?.discountApprovalMode ?? 'token'
  const usesTokenFlow = discountApprovalMode === 'token'
  const hasDiscount = state == 'REQUEST'
  const hasGiftSale = verifyHasGiftSale(sum, client, responsibleAssociate, shoppingCart)
  const isAuthorizedToSkipTokenRequest = useAuthorization('sales.approve_discounts')
  const isAuthorizedToApproveRestrictClient = useAuthorization('sales.approve_restrict_client')
  const restrictClientBlocked =
    isRestrictClient && !isRestrictClientApproved && !isAuthorizedToApproveRestrictClient

  // No fluxo de token, quem tem a permissão de aprovar descontos dispensa a aprovação.
  // No fluxo de análise, apenas um aprovador ativo dispensa o envio para análise.
  const isAuthorizedToSkip = usesTokenFlow
    ? isAuthorizedToSkipTokenRequest
    : !!currentUser?.isSaleApprover

  // Orçamento carregado que aguarda análise do desconto e pode ser aprovado/reprovado pelo aprovador.
  const isBudgetPendingReview = budgetData?.discountReviewStatus === 'pending'
  const isBudgetRejected = budgetData?.discountReviewStatus === 'rejected'
  const canReviewBudget = isBudgetPendingReview && !!currentUser?.isSaleApprover
  const [loadingReview, setLoadingReview] = useState(false)
  const expiresAtBudget = isExpiresAtBudget(budgetData)

  const reviewBudget = async (approved: boolean) => {
    const {value: observation, isConfirmed} = await Swal.fire({
      title: approved ? 'Aprovar desconto do orçamento?' : 'Reprovar desconto do orçamento?',
      input: 'textarea',
      inputLabel: 'Observação (opcional)',
      inputPlaceholder: 'Escreva uma observação sobre a análise...',
      showCancelButton: true,
      confirmButtonText: approved ? 'Aprovar' : 'Reprovar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: approved ? 'btn btn-success' : 'btn btn-danger',
        cancelButton: 'btn btn-secondary',
      },
    })

    if (!isConfirmed) {
      return
    }

    setLoadingReview(true)
    try {
      const request = approved ? approveBudgetReview : rejectBudgetReview
      await request(String(budgetData?.id), observation || undefined)
      setBudgetData({
        ...budgetData,
        discountReviewStatus: approved ? 'approved' : 'rejected',
      })
      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: approved ? 'Desconto aprovado com sucesso' : 'Desconto reprovado',
        showConfirmButton: false,
        timer: 2000,
      })
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error?.response?.data?.message,
        timer: 2000,
      })
    } finally {
      setLoadingReview(false)
    }
  }

  const handleBudget = () => {
    if (isAuthorizedToSkip || !hasDiscount) {
      createBudget()
      return
    }
    setActionPayment('BUDGET')
    setOpenTokenModal(true)
  }

  const handleGiftSale = () => {
    setActionPayment('GIFT')
    if (isAuthorizedToSkip) {
      createGiftSale()
      return
    }
    setOpenTokenModal(true)
  }

  const createGiftSale = async () => {
    setLoadingSale(true)
    try {
      const data = await generateGiftSale()
      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: `Venda gerada com sucesso!!!`,
        showConfirmButton: false,
        timer: 2000,
      })

      setLoadingSale(false)
      navigate(`/sales/list/${data?.id}`)
    } catch (error: any) {
      if (error.response.status === 422) {
        let errorText = ''
        for (let key in error.response.data.errors) {
          errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
        }
        await Swal.fire({
          icon: 'error',
          title: 'Ops! Revise seu formulário e tente novamente!',
          customClass: {
            confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
            cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
          },
          html: errorText,
        })
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          customClass: {
            confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
            cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
          },
          text: error.response.data.message,
        })
      }
      setLoadingSale(false)
    }
  }

  const [_, setSearchParams] = useSearchParams()
  const createBudget = async () => {
    setLoading(true)

    try {
      const data = await generateBudget()
      if (!client?.email) {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Você não possui email clique no botão abaixo para copiar o link de orçamento',
          confirmButtonText: 'Copiar link de orçamento',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const encryptId = Array(data).map((data) => data?.encryptId)
            copyToBudget(String(encryptId))
          }
        })
      } else {
        await Swal.fire({
          position: 'center',
          icon: 'success',
          title: `Orçamento ${isUpdate ? 'atualizado' : 'gerado'} com sucesso`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
      setLoading(false)
      setEnableBudget(false)
      setBudgetForSale(data?.id)
      if (data) {
        setSearchParams(
          (state) => {
            state.set('budget', String(data?.id))
            return state
          },
          {replace: true}
        )
      }
    } catch (error: any) {
      setLoading(false)
      if (error.response.status === 422) {
        let errorText = ''
        for (let key in error.response.data.errors) {
          errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
        }
        await Swal.fire({
          icon: 'error',
          title: 'Ops! Revise seu formulário e tente novamente!',
          html: errorText,
        })
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.message,
          timer: 2000,
        })
      }
    }
  }

  const verifyClient = (client, hasGiftSale) => {
    if (client) {
      const hasEmptyAddress = client.addresses.some((address) => {
        return (
          address.complement === '' ||
          address.number === '' ||
          address.city?.length === 0 ||
          address.neighborhood === '' ||
          address.street === '' ||
          address.zipCode === ''
        )
      })

      const addressesEmpty = client.addresses.length === 0
      const contactEmpty = client.contacts.length === 0
      const emailEmpty = client.email === '' || client.email === null

      const hasEmptyPhysicalPerson =
        client.physicalPerson &&
        (client.physicalPerson.age === null ||
          client.physicalPerson.birthDate === '' ||
          client.physicalPerson.document === '' ||
          client.physicalPerson.gender === '' ||
          client.physicalPerson.nationality?.length === 0 ||
          client.physicalPerson.zipCode === '')

      if (
        hasEmptyAddress ||
        contactEmpty ||
        emailEmpty ||
        hasEmptyPhysicalPerson ||
        addressesEmpty
      ) {
        setShowEditPersonModal(true)
      } else {
        if (hasGiftSale) {
          return handleGiftSale()
        }
        setActionPayment('BUDGET')
        return setShowPaymentModal(true)
      }
    }
  }

  const disabledSale = verifyDisableButton(sum, client, responsibleAssociate, shoppingCart)
  const disabledBudget = verifyDisableBudgetButton(sum, client, shoppingCart)
  const isAuthorizedToCreateBudget = useAuthorization('budgets.create')
  const isAuthorizedToUpdateBudget = useAuthorization('budgets.update')

  const isAuthorizedBudget = (budgetData) => {
    const newBudget = isNewBudget(budgetData)

    if (newBudget) {
      return isAuthorizedToCreateBudget
    } else {
      return isAuthorizedToUpdateBudget
    }
  }

  return (
    <>
      {loading && (
        <LoadingBudget title={isUpdate ? 'Atualizando orçamento' : 'Gerando orçamento'} />
      )}

      {loadingSale && <LoadingBudget title={'Gerando Venda'} />}
      {loadingReview && <LoadingBudget title={'Processando análise'} />}

      {isBudgetRejected ? (
        <div className='col-12 px-1'>
          <div className='alert alert-danger d-flex flex-column mb-0'>
            <span className='fw-bold'>Desconto reprovado</span>
            <span className='fs-7'>
              O desconto deste orçamento foi reprovado na análise; não é possível gerar a venda.
            </span>
          </div>
        </div>
      ) : isBudgetPendingReview ? (
        <div className='col-12 px-1'>
          <div className='alert alert-warning d-flex flex-column mb-3'>
            <span className='fw-bold'>Orçamento em análise de desconto</span>
            <span className='fs-7'>
              {canReviewBudget
                ? 'Aprove ou reprove o desconto para liberar a geração da venda.'
                : 'Este orçamento só poderá virar venda após a aprovação do desconto por um aprovador.'}
            </span>
          </div>
          <div className='d-flex flex-column flex-lg-row gap-2'>
            {isAuthorizedBudget(budgetData) && !disabledBudget && !restrictClientBlocked && (
              <div className='flex-fill'>
                <BudgetButton budget={budget} action={() => handleBudget()} />
              </div>
            )}
            {canReviewBudget && (
              <>
                <button
                  type='button'
                  className='btn btn-success flex-fill text-truncate'
                  style={{minWidth: 0}}
                  disabled={loadingReview}
                  onClick={() => reviewBudget(true)}
                >
                  Aprovar desconto
                </button>
                <button
                  type='button'
                  className='btn btn-danger flex-fill text-truncate'
                  style={{minWidth: 0}}
                  disabled={loadingReview}
                  onClick={() => reviewBudget(false)}
                >
                  Reprovar desconto
                </button>
              </>
            )}
          </div>
        </div>
      ) : expiresAtBudget ? (
        <div className='col-12 text-center'>
          <div className='bg-warning-subtle text-warning-emphasis p-3 rounded border border-warning-subtle'>
            <span className='fw-bold d-block w-auto'>
              Prazo do orçamento vencido. Será necessário realizar o lançamento de uma nova
              venda/orçamento.
            </span>
          </div>
        </div>
      ) : (
        <>
          {sale == null && isAuthorizedBudget(budgetData) && (
            <div className='col-6 px-1'>
              {!disabledBudget && !restrictClientBlocked && (
                <BudgetButton budget={budget} action={() => handleBudget()} />
              )}
            </div>
          )}

          <div className={sale ? 'col-12 align-items-end justify-content-end' : 'col-6 px-1'}>
            {!disabledSale && !restrictClientBlocked && (
              <SaleButton badge={badge} action={() => verifyClient(client, false)} />
            )}

            {hasGiftSale && !restrictClientBlocked && (
              <SaleButton badge={badge} action={() => verifyClient(client, true)} />
            )}
          </div>
        </>
      )}

      {openTokenModal &&
        (usesTokenFlow ? (
          <TokenModalSale
            action={() => {
              if (actionPayment === 'BUDGET') {
                createBudget()
              } else if (actionPayment === 'GIFT') {
                createGiftSale()
              }
            }}
            close={() => setOpenTokenModal(false)}
          />
        ) : (
          <NoticeModalSale
            message={
              actionPayment === 'BUDGET'
                ? 'Este orçamento depende de análise e aprovação do desconto antes de virar uma venda.'
                : 'Esta venda depende de análise e aprovação antes de ser concluída.'
            }
            action={() => {
              if (actionPayment === 'BUDGET') {
                createBudget()
              } else if (actionPayment === 'GIFT') {
                createGiftSale()
              }
            }}
            close={() => setOpenTokenModal(false)}
          />
        ))}
    </>
  )
}
